import { Folder } from '@/types/folder';

export const folder = (baseUrl: string, fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>) => {
  return {
    /**
     * Get all folders.
     * @returns
     */
    list: async (): Promise<Folder[] | null> => {
      const url = `${baseUrl}/List`;
      const response = await fetchWithAuth(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.debug('folder.list response', data);
      return data;
    },

    /**
     * Create a new folder.
     * @param name Folder name
     * @param parentFolderId Parent folder to place new folder in, undefined is top-level
     * @returns
     */
    create: async (name: string, parentFolderId: number | undefined) => {
      const url = `${baseUrl}/Create`;
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name, parentFolderId })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      console.debug('folder.create response', response);
      return response;
    },

    /**
     * Move folder under given parent.
     * @param folderId Folder ID
     * @param parentFolderId Parent fodler to place folder in, undefined is top-level
     * @returns
     */
    move: async (folderId: number, parentFolderId: number | undefined) => {
      const url = `${baseUrl}/Move`;
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ folderId, parentFolderId })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      console.debug('folder.move response', response);
      return response;
    },

    /**
     * Remove a folder
     * @param folderId Folder ID
     * @returns
     */
    remove: async (folderId: number) => {
      const url = `${baseUrl}/Remove`;
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ folderId })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      console.debug('folder.remove response', response);
      return response;
    },

    /**
     * Rename a folder
     * @param folderId Folder ID
     * @param name New Folder name
     * @returns
     */
    rename: async (folderId: number, name: string) => {
      const url = `${baseUrl}/Rename`;
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ folderId, name })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      console.debug('folder.rename response', response);
      return response;
    }
  };
};
